import { SET_TRANSACTION_HISTORY_SUCCESS,SET_TRANSACTION_HISTORY_ERROR,
         SET_TRANSACTION_SUMMARY_SUCCESS, SET_TRANSACTION_SUMMARY_ERROR,
         RESET_HISTORY_FLAGS } from "../actionTypes";

const initialState = {
    transactionHistory:[],
    transactionSummary:{},
    historyResponseErr:false,
    historyResponseSuccess:false,
    summaryResponseErr:false
}

const transcriptHistory = (state = initialState, action) => {
    switch (action.type) {
        case SET_TRANSACTION_HISTORY_SUCCESS:{
            return{
                ...state,
                transactionHistory: action.payload.tHistory,
                historyResponseSuccess:true
            }
        }
        case SET_TRANSACTION_HISTORY_ERROR:{
            return{
                ...state,
                transactionHistory:[],
                historyResponseErr:true
            }
        }
        case SET_TRANSACTION_SUMMARY_SUCCESS:{
            return{
                ...state,
                transactionSummary: action.payload.tSummary
            }
        }
        case SET_TRANSACTION_SUMMARY_ERROR:{
            return{
                ...state,
                transactionSummary:{},
                summaryResponseErr:true
            }
        }
        case RESET_HISTORY_FLAGS:{
            return{
                ...state,
                summaryResponseErr:false,
                historyResponseErr:false,
                historyResponseSuccess:false
            }            
        }
        default: {
            return state;
        }            
    }
}
export default transcriptHistory;